document.addEventListener('DOMContentLoaded', function() {
    const botonesPassword = document.querySelectorAll('.formulario__toggle-password');

    botonesPassword.forEach(boton => {
        boton.addEventListener('click', function() {
            const inputPassword = document.getElementById(boton.dataset.target);
            const icono = boton.querySelector('i');

            if(!inputPassword || !icono) return;

            if(inputPassword.type === 'password') {
                inputPassword.type = 'text';
                icono.classList.remove('fa-eye');
                icono.classList.add('fa-eye-slash');
            } else {
                inputPassword.type = 'password';
                icono.classList.remove('fa-eye-slash');
                icono.classList.add('fa-eye');
            }
        });
    });
});